





























































import { Component, Prop, PropSync } from "vue-property-decorator";
import { mapState } from "vuex";
import RequestPromises from "@/mixins/requestPromises";
import { mixins } from "vue-class-component";

@Component({
  computed: {
    ...mapState({
      cardTypes(state, getters) {
        return getters["data/listArray"]({
          storeModule: this.cardTypesDataModule,
          scope: this.cardTypesDataScope
        });
      }
    })
  }
})
export default class GatewayProviderSettings extends mixins(RequestPromises) {
  @Prop({ required: true })
  public gatewaySettings!: string[];

  @Prop({ required: true })
  public isProcessing!: boolean;

  @PropSync("gatewayProviderSettings", { required: true })
  public gatewayProviderSettingsSynced!: { [key: string]: string };
}
